<template>
  <div></div>
</template>

<script>
    export default {
      name: "Logout",
      beforeCreate() {
        this.$store.dispatch("auth/logout").then(() => {
          this.$router.push({name: 'login'});
        });
      }
    }
</script>
